import React from 'react';
import { i18n } from 'config/locales';
import { Summary, AddressSummary, DateSummary } from 'components/Summary';
import { FOREIGN, FOREIGN_ACTIVITIES_CURRENT } from 'config/formSections/foreign';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import CurrentBenefit from './CurrentBenefit';

const sectionConfig = {
  key: FOREIGN_ACTIVITIES_CURRENT.key,
  section: FOREIGN.name,
  store: FOREIGN.store,
  subsection: FOREIGN_ACTIVITIES_CURRENT.name,
  storeKey: FOREIGN_ACTIVITIES_CURRENT.storeKey,
};
export class CurrentActivity extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasCurrentActivity: this.props.HasCurrentActivity,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasCurrentActivity = (values) => {
    this.update({
      HasCurrentActivity: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  summary = (item, index) => {
    const o = (item || {}).Item || {};
    const who = ((o.InterestTypes || {}).values || []).join(', ');
    const acquired = DateSummary(o.Acquired);
    const address = AddressSummary(o.Address, '');
    const summary = [who, address].reduce((prev, next) => {
      if (prev && next) {
        return <span>{`${prev} - ${next.props.children}`}</span>;
      }
      return prev;
    });

    return Summary({
      type: i18n.t('foreign.pvq.activities.collection.itemType.current'),
      index,
      left: who || address ? summary : '',
      right: acquired,
      placeholder: i18n.t('foreign.pvq.activities.collection.summary.current'),
    });
  };

  render() {
    const { errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);

    return (
      <div
       
        data-section={FOREIGN.key}
        data-subsection={FOREIGN_ACTIVITIES_CURRENT.key}
      >
         <h1 className="section-header">{i18n.t('foreign.pvq.activities.current.heading.title')}</h1>
        
        
        <Branch
          name="has_interests"
         label = {i18n.m('foreign.pvq.activities.currentTitle')}
     
      
          labelSize="h4"
          {...this.props.HasCurrentActivity}
          warning
          onError={this.handleError}
          // required={this.props.required}
          onUpdate={this.updateHasCurrentActivity}
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasCurrentActivity"
        />

        <Show when={this.props.HasCurrentActivity.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary}
            onUpdate={this.updateList}
            onError={this.handleError}
            errors={accordionErrors}
           
           
            appendMessage={i18n.m('foreign.pvq.activities.currentMessage')}
           
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <CurrentBenefit
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
              peopleWhoKnowYou={this.props.peopleWhoKnowYou}
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

CurrentActivity.defaultProps = {
  name: 'current',
  HasCurrentActivity: {},
  List: {},
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'foreign',
  subsection: 'activities/current',
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(CurrentActivity, sectionConfig);
